
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/yaml-to-xml",
      function () {
        return require("private-next-pages/converter/yaml-to-xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/yaml-to-xml"])
      });
    }
  